module.exports = __webpack_public_path__ + "img/brand-15.d8139259.png";